(function () {
  function initKbkSliders() {
    document.querySelectorAll('[data-kbk-slider]').forEach(function (slider) {
      if (slider.dataset.kbkInit) return;
      slider.dataset.kbkInit = '1';

      var track = slider.querySelector('[data-kbk-track]');
      var btnPrev = slider.querySelector('[data-kbk-prev]');
var btnNext = slider.querySelector('[data-kbk-next]');
      if (!track) return;

      function scrollToSlide(dir) {
  var index = Math.round(track.scrollLeft / track.offsetWidth);
  index = dir === 'next' ? index + 1 : index - 1;
  track.scrollTo({ left: index * track.offsetWidth, behavior: 'smooth' });
}
if (btnPrev) btnPrev.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); scrollToSlide('prev'); });
if (btnNext) btnNext.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); scrollToSlide('next'); });

      // Desktop mouse drag
      var dragging = false, startX = 0, scrollStart = 0;
      track.addEventListener('mousedown', function (e) {
        dragging = true; startX = e.clientX; scrollStart = track.scrollLeft;
        track.classList.add('is-grabbing'); e.preventDefault();
      });
      window.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        track.scrollLeft = scrollStart - (e.clientX - startX);
      });
      window.addEventListener('mouseup', function () {
        if (!dragging) return;
        dragging = false; track.classList.remove('is-grabbing');
        var index = Math.round(track.scrollLeft / track.offsetWidth);
        track.scrollTo({ left: index * track.offsetWidth, behavior: 'smooth' });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initKbkSliders);
  document.addEventListener('shopify:section:load', initKbkSliders);
})();
